export default "__VITE_ASSET__Chud0wJZ__"